import { useState, useCallback } from 'react';
import useAuth from './useAuth';

const API_BASE = (process.env.REACT_APP_API_URL || "https://ukd45lve3kvj45tahklem6d67q0fbbxm.lambda-url.us-west-2.on.aws/api/chat").replace('/api/chat', '');

export default function useActions() {
    const auth = useAuth();
    const [actions, setActions] = useState([]);
    const [loading, setLoading] = useState(false);

    const getHeaders = useCallback(async () => {
        const headers = { "Content-Type": "application/json" };
        const token = await auth?.getIdToken();
        if (token) headers["Authorization"] = `Bearer ${token}`;
        return headers;
    }, [auth]);

    const fetchActions = useCallback(async () => {
        setLoading(true);
        try {
            const headers = await getHeaders();
            const res = await fetch(`${API_BASE}/api/actions`, { headers });
            if (res.ok) {
                const data = await res.json();
                setActions(data.actions || []);
            }
        } catch (e) {
            console.error("Failed to fetch actions", e);
        } finally {
            setLoading(false);
        }
    }, [getHeaders]);

    const createAction = useCallback(async (text, estimatedMinutes) => {
        try {
            const headers = await getHeaders();
            const res = await fetch(`${API_BASE}/api/actions`, {
                method: "POST",
                headers,
                body: JSON.stringify({ text, estimated_minutes: estimatedMinutes }),
            });
            if (res.ok) {
                const data = await res.json();
                setActions(prev => [{ ...data, created_at: Math.floor(Date.now() / 1000), completed_at: 0 }, ...prev]);
                return true;
            }
        } catch (e) {
            console.error("Failed to create action", e);
        }
        return false;
    }, [getHeaders]);

    const completeAction = useCallback(async (actionId) => {
        try {
            const headers = await getHeaders();
            const res = await fetch(`${API_BASE}/api/actions/${actionId}`, {
                method: "PATCH",
                headers,
                body: JSON.stringify({ status: "completed" }),
            });
            if (res.ok) {
                setActions(prev => prev.map(a =>
                    a.action_id === actionId
                        ? { ...a, status: "completed", completed_at: Math.floor(Date.now() / 1000) }
                        : a
                ));
                return true;
            }
        } catch (e) {
            console.error("Failed to complete action", e);
        }
        return false;
    }, [getHeaders]);

    const deleteAction = useCallback(async (actionId) => {
        try {
            const headers = await getHeaders();
            const res = await fetch(`${API_BASE}/api/actions/${actionId}`, {
                method: "DELETE",
                headers,
            });
            if (res.ok) {
                setActions(prev => prev.filter(a => a.action_id !== actionId));
                return true;
            }
        } catch (e) {
            console.error("Failed to delete action", e);
        }
        return false;
    }, [getHeaders]);

    return { actions, loading, fetchActions, createAction, completeAction, deleteAction };
}
